import React, { Component } from 'react'
import { connect } from 'react-redux'

class BkFlowEditGuestFieldCats extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const { configData, enableCats, toggleCats } = this.props

		const hotelLabels = configData.hotel.labels[0]

		return (
			<div className="bk-flow-edit-guest__field-col half">
				<p className="bk-flow-edit-guest__field-heading u-font-xs u-remove-margin">{ hotelLabels.cat }</p>
				<button
					className={ enableCats ? 'bk-flow-edit-guest__field-check decrement active row' : 'bk-flow-edit-guest__field-check decrement row' }
					onClick={ () => toggleCats() }
					tabIndex={ 1 }
				>
					<div className="bk-flow-edit-guest__field-check-box col-xs"></div>
					<div className="bk-flow-edit-guest__field-check-icon cats col-xs"></div>
				</button>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration
})

export default connect(mapStateToProps, null)(BkFlowEditGuestFieldCats)


// WEBPACK FOOTER //
// ./src/components/edit/guest/elements/BkFlowEditGuestFieldCats.js